import GraphqlBase from './graphql-base'

import { generateQuery } from './graphql-helpers'
import { omitDeep } from 'vessel/utils'

export default class GraphqlQuery extends GraphqlBase {
  constructor({ query, collection, variables, ...options }) {
    super(options)

    this.query      = query
    this.collection = collection
    this.variables  = variables
    this.generator  = generateQuery
  }

  get file() {
    return this.query || (this.collection ? 'Collection' : 'Record')
  }

  get dataObject() {
    return {
      fullData: null,
      data: null,
      hasData: false,
      error: null,
      loading: false,
      total: null,
      pager: {
        hasPreviousPage: false,
        hasNextPage: false,
        startCursor: null,
        endCursor: null
      }
    }
  }

  get attrs() {
    return {
      query: this.definition,
      clientId: this.client,
      variables: {
        where: {},
        ...this.variables
      },
      ...this.options,
      options: {
        ...this.options.options,
        context: this.context
      }
    }
  }

  hasData(data) {
    return this.collection
      ? (data && data.length > 0)
      : (data && Object.keys(data).length > 0)
  }

  parseData(data) {
    if (data && this.parser) {
      const parseItem = item => this.parser.call(null, item)

      return Array.isArray(data)
        ? data.map(parseItem)
        : parseItem(data)
    }

    return data
  }

  parseResult(result) {
    const parsed = this.dataObject
    const data   = Object(result.data)
    const objKey = this.root || Object.keys(data)[0]
    const object = omitDeep(data[objKey], ['__typename'])

    parsed.fullData = result.data
    parsed.error    = result.error
    parsed.loading  = result.loading

    if (object) {
      if (this.collection && !Array.isArray(object)) {
        const { total, nodes, pageInfo } = object

        parsed.data  = this.parseData(nodes)
        parsed.total = total
        parsed.pager = { ...parsed.pager, ...pageInfo }
      } else {
        parsed.data  = this.parseData(object)
      }

      parsed.hasData = this.hasData(parsed.data)
    }

    return parsed
  }

  async execute(provider) {
    const client = provider.clients[this.client]

    return client.query({ ...this.attrs, context: this.context })
      .then(res => this.parseResult(res))
      .catch(res => console.log(res))
  }
}
